<div
  systemNotification
  *ngIf="message"
  [message]="message"
  [messageType]="messageType"
  (close)="closeSystemNotification()"
></div>

<app-loading-bar></app-loading-bar>
<router-outlet></router-outlet>

<!-- Custom modal setup -->
<div id="modal-container" class="hidden" #modalContainer></div>
